import React, { useState,useEffect,useRef } from 'react'
import { Dropdown } from 'react-bootstrap'

import ModalFastMessage from '../../../pages/modals/modal-fast-message';
import ModalCoordenates from '../../../pages/modals/modal-coordenates';
import ModalEditMessage from '../../../pages/modals/modal-edit-message';

import ShowMessages from '../../../components/Exceptions'
import Swal from 'sweetalert2'
import { useChatData } from './../chatContext'

import api from '../../../services/api'
import {  differenceInMinutes } from 'date-fns'

import EmojiPicker from 'emoji-picker-react';

export default function OptionChat({ props, allocMessage, onResponse, setConversation, username }) {
    const [dataCoordenates, setDataCoordenates]           = useState({})
    const [showModalCoordinates, setShowModalCoordinates] = useState(false)
    const [dataFastMessage, setDataFastMessage]           = useState([])
    const [showModalFastMessage, setShowModalFastMessage] = useState(false)
    const [showModalEditMessage, setShowModalEditMessage] = useState(false)
    const [dataEdit, setDataEdit]                         = useState({})
    const [position,setPosition]                          = useState(null)
    const [positionEmoji,setPositionEmoji]                = useState(null)
    const [showReactions, setShowReactions]               = useState(false)
    const [showEmoji, setShowEmoji]                       = useState(false)

    const { to, number } = useChatData()

    const divRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (divRef.current && !divRef.current.contains(event.target)) {
            setShowReactions(false); // Chama a ação ao clicar fora
          }
        };
    
        document.addEventListener("mousedown", handleClickOutside);
    
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const createReaction = (e) => {
        const rect = e.target.getBoundingClientRect();
        setPosition({
            top: rect.top - 140, // Posição abaixo da opção clicada
            left: rect.left - 95, // Alinhado à esquerda da opção clicada
        });
        setShowEmoji(false)
        setShowReactions(true)
       // alert("Em desenvolvimento, informe ao suporte a sua necessidade de uso!")
    }   

    const handleSelectedEmoji = (emoji) => {
        alert("Em desenvolvimento, informe ao suporte a sua necessidade de uso!")
    }

    const handleEmoji = (e) => {
        const rect = e.target.getBoundingClientRect();
        setPositionEmoji({
            top: rect.top - 440, // Posição abaixo da opção clicada
            left: 0, // Alinhado à esquerda da opção clicada
        });
        setShowEmoji(true)
    }
    const createResponse = () => {
        onResponse()
        setConversation({...props,username})
    }

    const editMessage = async (idmessage, isEdit) => {
        await api.post('/getMessageFromId', { idmessage })
            .then(async (response) => {
                if (response.data) {
                    setDataEdit({
                        isEdit,
                        idmessage,
                        to,
                        number,
                        messageList: response.data.editedhistory ? [...response.data.editedhistory, {
                            body: response.data.body,
                            create_at: response.data.create_at
                        }] : [{
                            body: response.data.body,
                            create_at: response.data.create_at
                        }]
                    })
                    setShowModalEditMessage(true)
                }
            })
            .catch((error) => {
                ShowMessages(error)
            })
    }

    const DeleteMessage = async(props) => {
        Swal.fire({
            title: 'Confirmação',
            text: "Deseja realmente apagar a mensagem selecionada?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await api.post('/deleteMessage', {
                    number : number,
                    chatnumber : to,
                    idmessage : props.idmessage
                })
                    .then((response) => {                       
                        ShowMessages(response)
                    }).catch(error => {
                        ShowMessages(error)
                    })
            }

        })
    }

    const handleCoordinates = (latitude, longitude) => {
        setDataCoordenates({ latitude, longitude })
        setShowModalCoordinates(true)
    }
    
    const createFastMessage = async(_conversation) => {
        setDataFastMessage(_conversation)
        setShowModalFastMessage(true)
    }

    const handleCloseModalCoordenates = () => { setShowModalCoordinates(false) }
    const handleCloseModalFastMessage = () => { setShowModalFastMessage(false)}
    const handleCloseModalEdit        = () => { setShowModalEditMessage(false) }

    return (
        <>
            {showModalCoordinates && (<ModalCoordenates showModal={showModalCoordinates} handleCloseModal={handleCloseModalCoordenates} data={dataCoordenates} />)}
            {showModalFastMessage && (<ModalFastMessage showModal={showModalFastMessage} editState={false} handleCloseModal={handleCloseModalFastMessage} data={dataFastMessage}/>)}
            {showModalEditMessage && (<ModalEditMessage showModal={showModalEditMessage} handleCloseModal={handleCloseModalEdit} data={dataEdit} allocMessage={allocMessage} />)}

            {showReactions && (<div ref={divRef} style={{ position: "absolute", top: `${position?.top || 0}px`, left: `${position?.left || 0}px`, transform: "translateX(-50%)", background: "#fff", padding: "10px", borderRadius: "8px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", display: "flex", gap: "10px", border: "1px solid #ddd" }}>
                <div style={{ display: "flex", gap: "5px" }}>
                    <button type="button" className='icon-button-reaction' style={{ backgroundPosition: "0px" }} onClick={e => handleSelectedEmoji()} />
                    <button type="button" className='icon-button-reaction' style={{ backgroundPosition: "-39px" }} onClick={e => handleSelectedEmoji()}/>
                    <button type="button" className='icon-button-reaction' style={{ backgroundPosition: "-77px" }} onClick={e => handleSelectedEmoji()}/>
                    <button type="button" className='icon-button-reaction' style={{ backgroundPosition: "-115px" }} onClick={e => handleSelectedEmoji()}/>
                    <button type="button" className='icon-button-reaction' style={{ backgroundPosition: "-152px" }} onClick={e => handleSelectedEmoji()}/>
                    <button type="button" className='icon-button-reaction' style={{ backgroundPosition: "-189px" }} onClick={e => handleSelectedEmoji()}/>
                    <button type="button" onClick={e => handleEmoji(e)} style={{ width: "35px", height: "35px", background: "#f2f2f7", borderRadius: "50%", border: "0px", marginLeft: "10px", display: "flex", alignItems: "center", justifyContent: "center" }} title="Mais emojis">
                        <i className='fa fa-plus' style={{ fontSize: "22px", color: "#9f9999" }} />
                    </button>
                </div>
                {showEmoji && (
                    <div style={{ position: "absolute", top: `${positionEmoji?.top || 0}px`, marginLeft: `${positionEmoji?.left || 0}px` }}>
                        <EmojiPicker onEmojiClick={e => handleSelectedEmoji(e.emoji)} searchPlaceholder="Pesquisar" previewConfig={{
                            showPreview: false
                        }} categories={[
                            {
                                category: 'smileys_people',
                                name: 'Pessoas e Rostos',
                            },
                            {
                                category: 'animals_nature',
                                name: 'Animais e Natureza',
                            },
                            {
                                category: 'food_drink',
                                name: 'Comida e Bebida',
                            },
                            {
                                category: 'travel_places',
                                name: 'Viagem e Lugares',
                            },
                            {
                                category: 'activities',
                                name: 'Atividades',
                            },
                            {
                                category: 'objects',
                                name: 'Objetos',
                            },
                            {
                                category: 'symbols',
                                name: 'Símbolos',
                            },
                            {
                                category: 'flags',
                                name: 'Bandeiras',
                            }
                        ]} />
                    </div>
                )}
            </div>)}

            <Dropdown title='Opções' variant="success" style={{ textAlign: "right", display: "flex", height: "22px", width:"100%", justifyContent:'flex-end', cursor:"pointer",marginTop:"-15px",marginRight:"-70px"}} onClick={e => e.stopPropagation()}  className='show-over'>
                <Dropdown.Toggle style={{ padding: "0px", marginTop:"18px" }} variant="transparent" className='btn-transparent-chatbot btn-toogle-custom' >
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ padding: "0px" }} >
                    {differenceInMinutes(new Date(), props.create_at) < 15 && (!props.isreceive) && (
                        <>
                            <Dropdown.Item href="#" onClick={e => editMessage(props.idmessage, true)}>
                                <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                    <em className="fa fa-edit"></em>
                                    <span>Editar Mensagem</span>
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item href="#" onClick={e => DeleteMessage(props, true)}>
                                <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                    <em className="fa fa-trash"></em>
                                    <span>Apagar Mensagem</span>
                                </div>
                            </Dropdown.Item>
                        </>
                    )}
                
                    {props.edited && (
                        <Dropdown.Item href="#" onClick={e => editMessage(props.idmessage, false)}>
                            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                <em className="fa fa-grip-lines"></em>
                                <span>Visualizar Alterações</span>
                            </div>
                        </Dropdown.Item>
                    )}

                    {(props.type === 'location') && (
                        <Dropdown.Item href="#" onClick={e => handleCoordinates(props.location.latitude, props.location.longitude)}>
                            <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                <em className="fa fa-location-dot"></em>
                                <span>Visualizar Cordenadas</span>
                            </div>
                        </Dropdown.Item>
                    )}
                    <Dropdown.Item href="#" onClick={e => createReaction(e)}>
                        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                            <em className="fa fa-face-smile"></em>
                            <span>Reagir</span>
                        </div>
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={e => createResponse(props)}>
                        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                            <em className="fa fa-reply"></em>
                            <span>Responder</span>
                        </div>
                    </Dropdown.Item>
                    <Dropdown.Item href="#" onClick={e => createFastMessage(props)}>
                        <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                            <em className="fa fa-forward-fast"></em>
                            <span>Criar Mensagem Rápida</span>
                        </div>
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </>
    )
}